//-------- ADMIN APPLICATION MODULES
export const APPLICATION_MODULE = Object.freeze({
  CITY: 1,
  COMPANY: 2,
  STATE: 3,
  COUNTRY: 4,
  LAB: 5,
  SATELLITE: 6,
  LOCATION: 7,

  DASHBOARD: 202,
  PLATFORM_SELECTION: 61,
  USER: 301,

  PANEL: 400,
  SCALE: 401,
  PEN: 402,
  NOTE: 403,
  TRIAL: 404,
  ASSIGN_ACTION_ITEM: 405,
  LIVE_STATUS: 406,
  TOOLS: 407,
  CALIBRATION_DETAILS: 408,
  ADDRESS: 409,
  COMMENT: 410,
  RELEASE_NOTES: 416,
});

// ----- APPLICATION MODULES ALL ALLOWED ACTIONS
export const MODULE_ACTIONS = Object.freeze({
  VIEW: 1,
  ADD: 2,
  EDIT: 3,
  DELETE: 4,
  ACTIVE_INACTIVE_MARK: 5,
  LIST: 6,
  DATA_EXPORT: 188,
  CHANGE_STATUS: 400,

  VIEW_TRIAL_ANIMAL_DETAILS: 403,
  EDIT_TRIAL_ANIMAL_DETAILS: 404,
  APPROVAL: 405,
  VIEW_APPROVED_CALIBRATION_DETAILS: 406,
  RECENT_ACTION_ITEMS: 407,
  GRAPH_DATA: 408,
  LATEST_CALIBRATION_EVENTS: 409,
  RESEND_VERIFICATION_EMAIL: 410,
});

export const APP_ROLE = Object.freeze({
  ADMIN: "Admin",
  OTHER: "Other",
});
